import React from 'react'
import ContentLink from './ContentLink'
import TextOnly from './TextOnly'

const Versions = ({ item }) => {
    if (item === null) return null

    if(item.data.resource_type === "Website"){
        return null
    }
    else 
    return (
    <>
    <p className="h6 font-weight-bold">Other Versions</p>
    <ContentLink item={item}/>
    <TextOnly item={item}/>
    <hr/>
    </>
    )
}

export default Versions;